const exportTypes = {
  EXCEPTION_QUEUE: 'Exceptions',
};

export default exportTypes;
